module.exports = __webpack_public_path__ + "img/greenlight-logo.3c90a445.png";